import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import { partnerBrowserIDVerify } from '../../../utilities/partnerServices'

export const verifyBrowserId = createAsyncThunk(
    'validateSession', partnerBrowserIDVerify
)

const initialState = {
}

const validateSession = createSlice({
    name: 'validateSession',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(verifyBrowserId.pending, (state, action) => {
            })
            .addCase(verifyBrowserId.fulfilled, (state, action) => {
              if(action?.payload?.res?.ResponseDetails?.Available == 'true'){
                // action.payload.apiCall();
              }else{
                toast.error('Session Expired')
              }
            })
            .addCase(verifyBrowserId.rejected, (state, action) => {
            })
    },
})

export default validateSession.reducer